import { render, staticRenderFns } from "./topicDetail.vue?vue&type=template&id=77dd2ed1&scoped=true&"
import script from "./topicDetail.vue?vue&type=script&lang=js&"
export * from "./topicDetail.vue?vue&type=script&lang=js&"
import style0 from "./topicDetail.vue?vue&type=style&index=0&id=77dd2ed1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd2ed1",
  null
  
)

export default component.exports